export default "__VITE_ASSET__CFe6$jX___"